/* COLD BLOODED TEES — ported from the original main.js + homepage script */
(function () {
  var SECRET = ((window.CBT && window.CBT.secret) || 'REPTILE').toUpperCase();
  var HOVER_SEL = 'a,button,input,select,textarea,label,summary,.prod-card,.dc,.cs-card,.arc-item,.lw-item,.mf-tenet,.ed-vis';

  // ── CURSOR ──
  var cur = document.getElementById('cur'),
      cdot = document.getElementById('cur-dot'),
      cx2 = document.getElementById('cur-x');
  if (cur && cdot) {
    var mx = 0, my = 0, ccx = 0, ccy = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      cdot.style.left = mx + 'px'; cdot.style.top = my + 'px';
      if (cx2) { cx2.style.left = mx + 'px'; cx2.style.top = my + 'px'; }
    });
    (function anim() {
      ccx += (mx - ccx) * 0.12; ccy += (my - ccy) * 0.12;
      cur.style.left = ccx + 'px'; cur.style.top = ccy + 'px';
      requestAnimationFrame(anim);
    })();
    // Delegated so it also works for content Shopify loads later
    document.addEventListener('mouseover', function (e) {
      if (e.target.closest && e.target.closest(HOVER_SEL)) document.body.classList.add('hov');
    });
    document.addEventListener('mouseout', function (e) {
      var to = e.relatedTarget;
      if (!to || !to.closest || !to.closest(HOVER_SEL)) document.body.classList.remove('hov');
    });
  }

  // ── SCROLL REVEAL ──
  var obs = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } });
      }, { threshold: 0.08 })
    : null;
  function initReveal(root) {
    (root || document).querySelectorAll('.reveal:not(.visible)').forEach(function (r) {
      if (obs) obs.observe(r); else r.classList.add('visible');
    });
  }
  initReveal();

  // ── HERO AMBIENT PARALLAX ──
  window.addEventListener('scroll', function () {
    var y = window.scrollY, a = document.querySelector('.h-amb');
    if (a) a.style.transform = 'scale(' + (1 + y * 0.0003) + ') translateY(' + (y * 0.1) + 'px)';
  }, { passive: true });

  // ── LOGO GLITCH ──
  function initLogo(root) {
    var logo = (root || document).querySelector('.cbt-logo');
    if (!logo || logo.dataset.glitch) return;
    logo.dataset.glitch = '1';
    logo.addEventListener('mouseenter', function () {
      logo.style.filter = 'drop-shadow(2px 0 #C41230) drop-shadow(-2px 0 rgba(0,200,200,.4)) drop-shadow(0 0 40px rgba(139,0,0,.8))';
      setTimeout(function () { logo.style.filter = 'drop-shadow(0 0 30px rgba(139,0,0,.5))'; }, 200);
    });
  }
  initLogo();

  // ── MOBILE MENU (new: the original hid the nav on phones) ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.nav-burger');
    if (!btn) return;
    var list = document.getElementById(btn.getAttribute('aria-controls'));
    if (!list) return;
    var open = list.classList.toggle('open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.textContent = open ? 'Close' : 'Menu';
  });

  // ── SECRET DROP GATE ──
  function initSecret(root) {
    (root || document).querySelectorAll('[data-cbt-secret]').forEach(function (sec) {
      if (sec.dataset.ready) return;
      sec.dataset.ready = '1';
      var gate = sec.querySelector('.sec-gate'),
          open = sec.querySelector('.sec-open'),
          form = sec.querySelector('.sec-form'),
          input = sec.querySelector('.sec-form input'),
          err = sec.querySelector('.sec-err'),
          code = SECRET,
          key = 'cbt-secret-' + (sec.getAttribute('data-key') || '');
      function unlock() {
        if (gate) gate.hidden = true;
        if (open) { open.hidden = false; initReveal(open); }
      }
      var designMode = window.Shopify && window.Shopify.designMode;
      try { if (designMode || sessionStorage.getItem(key) === '1') unlock(); } catch (x) {}
      if (!form) return;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (input.value.trim().toUpperCase() === code && code !== '') {
          try { sessionStorage.setItem(key, '1'); } catch (x) {}
          unlock();
        } else {
          if (err) err.textContent = sec.getAttribute('data-denied') || 'Signal rejected';
          gate.classList.remove('denied'); void gate.offsetWidth; gate.classList.add('denied');
          input.value = '';
        }
      });
    });
  }
  initSecret();

  // Re-run when sections change in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target); initLogo(e.target); initSecret(e.target);
  });

  // ── KONAMI EASTER EGG ──
  var SEQ = ['ArrowUp','ArrowUp','ArrowDown','ArrowDown','ArrowLeft','ArrowRight','ArrowLeft','ArrowRight','b','a'];
  var seq = [];
  document.addEventListener('keydown', function (e) {
    seq.push(e.key); if (seq.length > SEQ.length) seq.shift();
    if (seq.join() === SEQ.join()) {
      var egg = document.getElementById('egg');
      if (egg) { egg.style.color = 'var(--red-hot)'; egg.textContent = '🐍 COLD BLOODED'; }
      console.log('%c COLD BLOODED TEES', 'color:#C41230;font-size:20px;font-weight:bold;font-family:monospace');
      console.log('%c Code: ' + SECRET, 'color:#8B0000;font-family:monospace');
    }
  });

  // ── CONSOLE EGG ──
  console.log('%c ▄▄▄ ▄▄▄ ▄▄▄', 'color:#C41230;font-family:monospace;font-size:14px');
  console.log('%c COLD BLOODED TEES — You were never supposed to find this.', 'color:#8B0000;font-size:11px;font-family:monospace');
  console.log('%c Hint: look at the logo letterforms. Secret: ' + SECRET, 'color:rgba(240,237,232,.25);font-size:10px;font-family:monospace');
})();
